import { getSdkHandler } from './native'

const name = '诺亚SDK'
const NOOP = () => void 0
const native = getSdkHandler()

async function showScreenRecorder() {
  return new Promise((resolve) => {
    native.callHandler('showScreenRecorder', undefined, resolve)
  })
}

function getScreenRecorderStatus(fn) {
  native.callHandler('getScreenRecorderStatus', undefined, fn)
}

function captureWebContent(data) {
  native.callHandler('captureWebContent', data);
}

function previewImagesToShare(data) {
  native.callHandler('previewImagesToShare', data)
}

function showRightIcon(data) {
  native.callHandler('showRightIcon', data)
}

function shareDirect(data) {
  native.callHandler('shareDirect', data)
}

const handler = native ? {
  name,
  init: () => native.init(),
  supports: (methodName) => typeof handler[methodName] === 'function',
  showScreenRecorder,
  getScreenRecorderStatus,
  captureWebContent,
  previewImagesToShare,
  showRightIcon,
  shareDirect
} : {
  name,
  init: NOOP,
  supports: () => false,
}

export default handler
